import { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar';

export const techRadarData: TechRadarLoaderResponse = {
  quadrants: [
    { id: 'languages', name: 'Languages' },
    { id: 'frameworks', name: 'Frameworks' },
    { id: 'infrastructure', name: 'Infrastructure' },
    { id: 'tools', name: 'Tools' },
  ],
  rings: [
    { id: 'adopt', name: 'Adopt', color: '#93c47d' },
    { id: 'trial', name: 'Trial', color: '#93d2c2' },
    { id: 'assess', name: 'Assess', color: '#fbdb84' },
    { id: 'hold', name: 'Hold', color: '#efafa9' },
  ],
  entries: [
    // === LANGUAGES ===
    {
      key: 'typescript',
      id: 'typescript',
      title: 'TypeScript',
      quadrant: 'languages',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'Lenguaje estandar en todos los microservicios' }],
      description: 'Lenguaje principal para backend y frontend. 100% de los microservicios lo usan.',
      url: 'https://www.typescriptlang.org/',
    },
    {
      key: 'nodejs',
      id: 'nodejs',
      title: 'Node.js 22',
      quadrant: 'languages',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'Runtime estandar para todos los servicios' }],
      description: 'Runtime principal. Version 22 LTS en produccion.',
      url: 'https://nodejs.org/',
    },
    {
      key: 'bun',
      id: 'bun',
      title: 'Bun',
      quadrant: 'languages',
      timeline: [{ ringId: 'adopt', date: new Date('2026-10-08'), moved: 1, description: 'Plantilla msa Bun y CD nestjs-bun-cd.yml' }],
      description: 'Runtime alternativo a Node.js para microservicios NestJS (plantilla deuna-msa-bun-template-repository).',
      url: 'https://bun.sh/',
    },
    {
      key: 'go',
      id: 'go',
      title: 'Go',
      quadrant: 'languages',
      timeline: [{ ringId: 'assess', date: new Date('2025-06-01'), moved: 0, description: 'Usado en DeunaCLI, evaluando para servicios de alto rendimiento' }],
      description: 'Usado actualmente solo en DeunaCLI. Potencial para servicios que requieran alto rendimiento.',
      url: 'https://go.dev/',
    },
    {
      key: 'javascript',
      id: 'javascript',
      title: 'JavaScript (sin tipos)',
      quadrant: 'languages',
      timeline: [{ ringId: 'hold', date: new Date('2024-01-01'), moved: 0, description: 'Migrar a TypeScript' }],
      description: 'Algunos servicios legacy aun usan JS sin tipos. Todos los nuevos deben usar TypeScript.',
    },

    // === FRAMEWORKS ===
    {
      key: 'nestjs',
      id: 'nestjs',
      title: 'NestJS',
      quadrant: 'frameworks',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'Framework principal para backend' }],
      description: 'Framework estandar para microservicios backend. ~40% de los repos lo usan explicitamente, el resto usa patrones compatibles.',
      url: 'https://nestjs.com/',
    },
    {
      key: 'apollo-graphql',
      id: 'apollo-graphql',
      title: 'Apollo GraphQL',
      quadrant: 'frameworks',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'API Gateway pattern para clientes mobile/web' }],
      description: 'Usado en los API Gateways (pp-api, ce-api, nb-gql, ag-gql-internal) para federar ~50 microservicios.',
      url: 'https://www.apollographql.com/',
    },
    {
      key: 'typeorm',
      id: 'typeorm',
      title: 'TypeORM',
      quadrant: 'frameworks',
      timeline: [{ ringId: 'trial', date: new Date('2024-06-01'), moved: 0, description: 'ORM para PostgreSQL en servicios NestJS' }],
      description: 'ORM usado en servicios que requieren acceso a PostgreSQL.',
      url: 'https://typeorm.io/',
    },
    {
      key: 'express',
      id: 'express',
      title: 'Express.js',
      quadrant: 'frameworks',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'HTTP server base para NestJS y servicios standalone' }],
      description: 'Servidor HTTP subyacente en NestJS y en servicios que no usan NestJS.',
      url: 'https://expressjs.com/',
    },
    {
      key: 'react',
      id: 'react',
      title: 'React 18',
      quadrant: 'frameworks',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'Frontend framework para Backstage y apps web' }],
      description: 'Usado en Backstage y aplicaciones web internas.',
      url: 'https://react.dev/',
    },
    {
      key: 'swagger-openapi',
      id: 'swagger-openapi',
      title: 'Swagger / OpenAPI',
      quadrant: 'frameworks',
      timeline: [{ ringId: 'assess', date: new Date('2025-01-01'), moved: 0, description: 'Documentacion REST en algunos servicios' }],
      description: 'Presente en ~15% de servicios con @nestjs/swagger. Evaluando estandarizacion.',
      url: 'https://swagger.io/',
    },

    // === INFRASTRUCTURE ===
    {
      key: 'docker',
      id: 'docker',
      title: 'Docker',
      quadrant: 'infrastructure',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'Containerizacion de todos los servicios' }],
      description: 'Todos los microservicios se empaquetan como imagenes Docker.',
      url: 'https://www.docker.com/',
    },
    {
      key: 'eks',
      id: 'eks',
      title: 'Amazon EKS',
      quadrant: 'infrastructure',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'Orquestacion Kubernetes en AWS' }],
      description: 'Clusters en 3 cuentas AWS (dev, qa, prod) + internal-tools.',
      url: 'https://aws.amazon.com/eks/',
    },
    {
      key: 'kafka',
      id: 'kafka',
      title: 'Apache Kafka',
      quadrant: 'infrastructure',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'Mensajeria asincrona entre microservicios' }],
      description: 'Usado en ~50% de los servicios para comunicacion asincrona via kafkajs.',
      url: 'https://kafka.apache.org/',
    },
    {
      key: 'redis',
      id: 'redis',
      title: 'Redis',
      quadrant: 'infrastructure',
      timeline: [{ ringId: 'trial', date: new Date('2024-06-01'), moved: 0, description: 'Cache y almacenamiento temporal' }],
      description: 'Usado en ~25% de servicios para cache, sesiones y datos temporales.',
      url: 'https://redis.io/',
    },
    {
      key: 'postgresql',
      id: 'postgresql',
      title: 'PostgreSQL',
      quadrant: 'infrastructure',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'Base de datos relacional principal' }],
      description: 'Base de datos principal via Zalando Postgres Operator en EKS.',
      url: 'https://www.postgresql.org/',
    },
    {
      key: 'aws-ecr',
      id: 'aws-ecr',
      title: 'Amazon ECR',
      quadrant: 'infrastructure',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'Registro de imagenes Docker' }],
      description: 'Todas las imagenes Docker se almacenan en ECR.',
      url: 'https://aws.amazon.com/ecr/',
    },
    {
      key: 'opensearch',
      id: 'opensearch',
      title: 'OpenSearch',
      quadrant: 'infrastructure',
      timeline: [{ ringId: 'assess', date: new Date('2025-01-01'), moved: 0, description: 'Busqueda avanzada de transacciones' }],
      description: 'Evaluando para busqueda avanzada y analytics de transacciones.',
      url: 'https://opensearch.org/',
    },

    // === TOOLS ===
    {
      key: 'github-actions',
      id: 'github-actions',
      title: 'GitHub Actions',
      quadrant: 'tools',
      timeline: [{ ringId: 'adopt', date: new Date('2026-03-01'), moved: 1, description: 'Reemplazo de Azure DevOps Pipelines' }],
      description: 'CI/CD principal desde Marzo 2026. Migrados 138 componentes desde Azure DevOps.',
      url: 'https://github.com/features/actions',
    },
    {
      key: 'argocd',
      id: 'argocd',
      title: 'ArgoCD',
      quadrant: 'tools',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'GitOps deployment para todos los servicios' }],
      description: 'Deployment GitOps. Todos los servicios se despliegan via ArgoCD.',
      url: 'https://argo-cd.readthedocs.io/',
    },
    {
      key: 'terraform',
      id: 'terraform',
      title: 'Terraform',
      quadrant: 'tools',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'Infrastructure as Code para AWS' }],
      description: 'IaC para toda la infraestructura AWS (EKS, ECR, IAM, secrets, etc.).',
      url: 'https://www.terraform.io/',
    },
    {
      key: 'helm',
      id: 'helm',
      title: 'Helm Charts',
      quadrant: 'tools',
      timeline: [{ ringId: 'trial', date: new Date('2024-06-01'), moved: 0, description: 'Packaging de manifests K8s' }],
      description: 'Charts para empaquetar deployments de Kubernetes.',
      url: 'https://helm.sh/',
    },
    {
      key: 'jest',
      id: 'jest',
      title: 'Jest',
      quadrant: 'tools',
      timeline: [{ ringId: 'adopt', date: new Date('2024-01-01'), moved: 0, description: 'Testing framework estandar' }],
      description: 'Framework de testing en ~80% de los repos.',
      url: 'https://jestjs.io/',
    },
    {
      key: 'sonarcloud',
      id: 'sonarcloud',
      title: 'SonarCloud',
      quadrant: 'tools',
      timeline: [{ ringId: 'trial', date: new Date('2024-06-01'), moved: 0, description: 'Analisis de calidad de codigo' }],
      description: 'Analisis estatico de codigo integrado con Backstage.',
      url: 'https://sonarcloud.io/',
    },
    {
      key: 'backstage',
      id: 'backstage',
      title: 'Backstage',
      quadrant: 'tools',
      timeline: [{ ringId: 'trial', date: new Date('2025-01-01'), moved: 0, description: 'Developer portal interno' }],
      description: 'Portal de desarrolladores con catalogo, CI/CD, K8s, Jira, SonarQube, Docs.',
      url: 'https://backstage.io/',
    },
    {
      key: 'azure-devops',
      id: 'azure-devops',
      title: 'Azure DevOps Pipelines',
      quadrant: 'tools',
      timeline: [{ ringId: 'hold', date: new Date('2026-03-01'), moved: -1, description: 'Migrado a GitHub Actions en Marzo 2026' }],
      description: 'Reemplazado por GitHub Actions. No usar para nuevos proyectos.',
    },
    {
      key: 'bitrise',
      id: 'bitrise',
      title: 'Bitrise',
      quadrant: 'tools',
      timeline: [{ ringId: 'hold', date: new Date('2025-06-01'), moved: -1, description: 'Removido del stack' }],
      description: 'CI/CD mobile removido. No usar.',
    },
  ],
};
